import type {
  ApiResponse,
  SearchLang,
  SearchMode,
  SearchResponse,
} from '@/types/api';

export type SearchInput = {
  q: string;
  mode: SearchMode;
  lang: SearchLang;
  limit?: number;
};

/**
 * Calls the `/api/search` Cloudflare Pages Function. Throws on
 * non-2xx or `ok: false` responses so TanStack Query can surface
 * the error through `useQuery`.
 */
export async function apiSearch(input: SearchInput): Promise<SearchResponse> {
  const params = new URLSearchParams({
    q: input.q,
    mode: input.mode,
    lang: input.lang,
  });
  if (input.limit) params.set('limit', String(input.limit));

  const res = await fetch(`/api/search?${params.toString()}`);
  const body = (await res.json()) as ApiResponse<SearchResponse>;

  if (!res.ok || !body.ok) {
    const message = !body.ok ? body.error.message : `HTTP ${res.status}`;
    throw new Error(message);
  }
  return body.data;
}
